import { EVENT_CHANGE_QUANTITY } from '../../constants/event';
import Quantity from '../../typs/quantity';
import ComponentBase from '../base/component-base';

class PartsQuantityComponent extends ComponentBase {
  protected _quantity: number = 1;
  protected quantityInputObserver: MutationObserver | null = null;

  protected quantityInputElement: HTMLInputElement | null = null;
  protected quantityUpButtonElement: HTMLButtonElement | null = null;
  protected quantityDownButtonElement: HTMLButtonElement | null = null;

  protected onQuantityChangeBinding: EventListener = () => {};

  constructor(element: HTMLElement) {
    super(element);
    this.init();
  }

  protected init() {
    this.initialize();
    this.setup();
  }

  protected initialize() {
    this.quantityInputElement = this.element.querySelector(
      '.j-parts-quantity-input'
    ) as HTMLInputElement;
    this.quantityUpButtonElement = this.element.querySelector(
      '.j-parts-quantity-up'
    ) as HTMLButtonElement;
    this.quantityDownButtonElement = this.element.querySelector(
      '.j-parts-quantity-down'
    ) as HTMLButtonElement;

    this.onQuantityChangeBinding = this.onQuantityChange.bind(this);
  }

  protected setup() {
    this.addEventListeners();
  }

  public updateQuantityMax(max: number): void {
    if (!this.quantityInputElement) return;
    this.quantityInputElement.max = String(max);
    if (Number(this.quantityInputElement.value) > max) {
      this.quantityInputElement.value = String(max);
    }
  }

  protected addEventListeners() {
    this.quantityInputElement?.addEventListener(
      'change',
      this.onQuantityChangeBinding
    );

    this.quantityUpButtonElement?.addEventListener('click', () => {
      this.quantityInputElement?.stepUp();
      this.quantityInputElement?.dispatchEvent(new Event('change'));
    });

    this.quantityDownButtonElement?.addEventListener('click', () => {
      this.quantityInputElement?.stepDown();
      this.quantityInputElement?.dispatchEvent(new Event('change'));
    });

    this.quantityInputObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        console.log(mutation);
      });
    });

    if (this.quantityInputElement) {
      this.quantityInputObserver.observe(this.quantityInputElement, {
        attributes: true,
        attributeFilter: ['max'],
      });
    }
  }

  protected onQuantityChange(event: Event): void {
    this.updateQuantity(Number(this.quantityInputElement?.value || 1));
    this.element.dispatchEvent(
      new CustomEvent(EVENT_CHANGE_QUANTITY, {
        detail: {
          quantity: this.quantity,
        } as Quantity,
      })
    );
  }

  protected updateQuantity(quantity: number): void {
    this._quantity = quantity;
  }

  public get quantity(): number {
    return this._quantity;
  }
}

export default PartsQuantityComponent;
